import {
  EDIT_RECEIVER_POSTAL_NAME,
  EDIT_RECEIVER_STATE_NAME,
  EDIT_RECEIVER_STREET_NAME,
  EDIT_RECEIVER_SUBURB_NAME,
} from 'constants';
import useGetConfig from 'hooks/useGetConfig';
import { isEmpty } from 'lodash';
import { useEffect, useState } from 'react';
import CustomCitiesDropdown from '../CustomCitiesDropdown';
import CustomSuburbsDropdown from '../CustomSuburbsDropdown';
import FormInputValidationWithFormatAndRegex from '../FormInputValidationWithFormatAndRegex';
import FormInputValidationWithFormatAndRegexExtendWithProp from '../FormInputValidationWithFormatAndRegexExtendWithProp';

const FormInputAddressManuallyValidation = ({
  field,
  countryConfig,
  cities,
  information,
  setInformation,
  validation,
  setValidation,
  portalCodeMaskStr,
  setPortalCodeMaskStr,
}) => {
  const [streetNameMaskStr, setStreetNameMaskStr] = useState('');
  const [stateNameMaskStr, setStateNameMaskStr] = useState('');
  const [suburbNameMaskStr, setSuburbNameMaskStr] = useState('');

  const { isEditReceiverEnterAddressManuallySelected } = information;

  const config = useGetConfig({ countryConfig });
  const {
    addressStreet,
    addressState,
    addressSuburb,
    addressPostcode,
    addressManualDisable,
  } = config;

  const isManual =
    !addressManualDisable &&
    (isEditReceiverEnterAddressManuallySelected || isEmpty(cities));

  const resetFormInput = () => {
    setStateNameMaskStr('');
    setSuburbNameMaskStr('');
  };
  useEffect(() => {
    if (!isManual) {
      resetFormInput();
    }
  }, [isManual, information]);

  const renderFieldDropdownReference = {
    [EDIT_RECEIVER_STATE_NAME]: addressState?.visible ? (
      <CustomCitiesDropdown
        field={field}
        isConfigRequired={addressState?.required}
        cities={cities}
        information={information}
        setInformation={setInformation}
        validation={validation}
        setValidation={setValidation}
      />
    ) : null,
    [EDIT_RECEIVER_SUBURB_NAME]: addressSuburb?.visible ? (
      <CustomSuburbsDropdown
        field={field}
        isConfigRequired={addressSuburb?.required}
        information={information}
        setInformation={setInformation}
        validation={validation}
        setValidation={setValidation}
      />
    ) : null,
  };
  const renderFieldManuallyReference = {
    [EDIT_RECEIVER_STATE_NAME]: addressState?.visible ? (
      <FormInputValidationWithFormatAndRegexExtendWithProp
        field={field}
        config={addressState}
        numberMaskStr={stateNameMaskStr}
        setNumberMaskStr={setStateNameMaskStr}
        countryConfig={countryConfig}
        prop="name"
        information={information}
        setInformation={setInformation}
        validation={validation}
        setValidation={setValidation}
        isAllowSpecificCharacter={true}
        isDisableTrim={true}
      />
    ) : null,
    [EDIT_RECEIVER_SUBURB_NAME]: addressSuburb?.visible ? (
      <FormInputValidationWithFormatAndRegexExtendWithProp
        field={field}
        config={addressSuburb}
        numberMaskStr={suburbNameMaskStr}
        setNumberMaskStr={setSuburbNameMaskStr}
        countryConfig={countryConfig}
        prop="name"
        information={information}
        setInformation={setInformation}
        validation={validation}
        setValidation={setValidation}
        isAllowSpecificCharacter={true}
        isDisableTrim={true}
      />
    ) : null,
  };

  if (field.name === EDIT_RECEIVER_STREET_NAME)
    return (
      <>
        {addressStreet?.visible ? (
          <FormInputValidationWithFormatAndRegex
            field={field}
            config={addressStreet}
            numberMaskStr={streetNameMaskStr}
            setNumberMaskStr={setStreetNameMaskStr}
            countryConfig={countryConfig}
            information={information}
            setInformation={setInformation}
            validation={validation}
            setValidation={setValidation}
            isAllowSpecificCharacter={true}
            isDisableTrim={true}
          />
        ) : null}
      </>
    );

  if (field.name === EDIT_RECEIVER_STATE_NAME)
    return (
      <>
        {isManual
          ? renderFieldManuallyReference[field.name]
          : renderFieldDropdownReference[field.name]}
      </>
    );

  if (field.name === EDIT_RECEIVER_SUBURB_NAME)
    return (
      <>
        {isManual
          ? renderFieldManuallyReference[field.name]
          : renderFieldDropdownReference[field.name]}
      </>
    );

  if (field.name === EDIT_RECEIVER_POSTAL_NAME)
    return (
      <>
        {addressPostcode?.visible ? (
          <FormInputValidationWithFormatAndRegex
            field={field}
            config={addressPostcode}
            numberMaskStr={portalCodeMaskStr}
            setNumberMaskStr={setPortalCodeMaskStr}
            countryConfig={countryConfig}
            information={information}
            setInformation={setInformation}
            validation={validation}
            setValidation={setValidation}
            isAllowSpecificCharacter={false}
            isDisableTrim={true}
          />
        ) : null}
      </>
    );

  return null;
};

export default FormInputAddressManuallyValidation;
